export const PageEvent = {
  APP_LOGOUT: 'app.logout',
  PROFILE_ACCOUNT_DELETED: 'profile.account.deleted',
  PROFILE_USER_UPDATED: 'profile.user.updated',
  PROFILE_PASSWORD_UPDATED: 'profile.password.updated',
}
